import "./App.css";
import "./Weather.css";

import Weather from "./Weather.js";

function App() {
  return (
    <div className="App">
      <Weather defaultCity="New York" />{" "}
    </div>
  );
}

export default App;
